export default {

}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/select-dates/resources/index.js